export default {"src":"/_next/static/media/tiktok.3d1748d5.svg","height":44,"width":152};